import { useEffect } from "react";
import { withAppContext } from "src/store/initAppContext";
import styled, { withTheme } from "styled-components";
import Accordion from '../../components/Accordion/Accordion';
import { getDamain } from "src/util/commonfun";
import { affiliateDateCrypto, bonusDataCrypto, DepositDataCrypto, myProfileDataCrypto, ProductsDataCrypto, securityDataCrypto } from "./faqDataCrypto";


function FAQ61(props: any) {

    const { app: {
        brandId
    }, theme } = props

    let WebsiteName = ''
    let WebsiteLink = ''
    switch (props.app.brandId) {
        case 31:
            WebsiteName = 'Yolo247';
            WebsiteLink = 'www.yolo247.live'
            break;
        case 32:
            WebsiteName = 'Yolo247';
            WebsiteLink = 'www.a-yolo247.site'
            break;
        case 33:
            WebsiteName = 'IW247';
            WebsiteLink = 'm.iw247.com'
            break;
        case 34:
            WebsiteName = 'BETDAILY';
            WebsiteLink = 'www.betdaily.club'
            break;
        case 39:
            WebsiteName = 'FOMO7';
            WebsiteLink = 'www.fomo7.co'
            break;
        case 46:
            WebsiteName = 'FUN88';
            WebsiteLink = 'www.fun88.com'
            break;
        case 61:
            WebsiteName = 'Yolo247';
            WebsiteLink = 'www.yolo247.io'
            break;
    }

    let domainURL = getDamain(brandId)

    const { config: { showAffiliate } } = theme;

    useEffect(() => {
        window.scrollTo(0, 0)
    })

    return (
        <>
            <ContentWrapper>
                <AccordionHead>My Account</AccordionHead>
                {myProfileDataCrypto.map((faq) => (
                    <Accordion
                        key={faq.id}
                        title={faq?.question}
                        content={() => ({ __html: faq?.answer })}
                        lists={faq?.lists}
                    // redirect={faq?.redirect}
                    />
                ))}

                <AccordionHead>Bonus Program</AccordionHead>
                {bonusDataCrypto.map((faq) => (
                    <Accordion
                        key={faq.id}
                        title={faq?.question}
                        content={() => ({ __html: faq?.answer })}
                        lists={faq?.lists}
                    // redirect={faq?.redirect}
                    />
                ))}

                <AccordionHead>Deposit & Withdrawal</AccordionHead>
                {DepositDataCrypto.map((faq) => (
                    <Accordion
                        key={faq.id}
                        title={faq?.question}
                        content={() => ({ __html: faq?.answer })}
                        lists={faq?.lists}
                    // redirect={faq?.redirect}
                    />
                ))}

                <AccordionHead>Products</AccordionHead>
                {ProductsDataCrypto.map((faq) => (
                    <Accordion
                        key={faq.id}
                        title={faq?.question}
                        content={() => ({ __html: faq?.answer })}
                        lists={faq?.lists}
                    // redirect={faq?.redirect}
                    />
                ))}

                <AccordionHead>Affiliate</AccordionHead>
                {affiliateDateCrypto.map((faq) => (
                    <Accordion
                        key={faq.id}
                        title={faq?.question}
                        content={() => ({ __html: faq?.answer })}
                        lists={faq?.lists}
                    // redirect={faq?.redirect}
                    />
                ))}

                <AccordionHead>Security</AccordionHead>
                {securityDataCrypto.map((faq) => (
                    <Accordion
                        key={faq.id}
                        title={faq?.question}
                        content={() => ({ __html: faq?.answer })}
                        lists={faq?.lists}
                    // redirect={faq?.redirect}
                    />
                ))}
            </ContentWrapper>
        </>
    );
}
export default withTheme(withAppContext(FAQ61));


const AccordionHead = styled.h1`
        font-size: 15px;
        color: #f4a322;
        margin-top:10px;
        margin: 1px 0px;
        padding: 5px 15px;
        background-color: #0000008a;
        `;
const ContentWrapper = styled.div`
	max-width: 800px;
	margin: 0 auto;
	font-size: 12px;
	padding: 1em 1.25em;

    h1{
        color: #EEBC15;
        
    }

    p,
	h3,
	h4,
	h5,
	h6 {
		color: #fff;
	}

	h1 {
		font-size: 18px;
	}

	h2 {
		font-size: 16px;
	}

	h3 {
		font-size: 14px;
	}

	ul ul,
	ol {
		margin: 1em 0;
	}

	li {
        color: #fff;
	}

	a {
		color: #EEBC15;
		text-decoration: underline;
	}

    span{
        font-weight: 700;
    }
`;
